import React from 'react'
import { Radio } from 'react-bootstrap'

const rfRadioGroup = ({ input, label, options }) => {
  return (
    <div>
      <label className="labelz">{label}</label>
      {Object.keys(options).map((name, i)=>
        <div key={i}>
          <Radio onChange={()=>input.onChange(name)} name={name} 
            checked={input.value===name} inline>
            <span style={{color:'black'}}>{options[name]}</span>
          </Radio>
        </div>
      )}
    </div>
  )
}

export default rfRadioGroup


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/rfRadioGroup.js